export const programOptions = () => {
    var acc = document.getElementsByClassName("options");
    var i;

    if (acc.length > 0) {
        for (i = 0; i < acc.length; i++) {
            acc[i].addEventListener("click", function() {
                console.log('clicked')
                this.classList.toggle("active");
                var panel = this.nextElementSibling;
                if (panel.style.maxHeight) {
                    panel.style.maxHeight = null;
                } else {
                    panel.style.maxHeight = panel.scrollHeight + "px";
                }
            });
        }
    }
};
